import { u_ } from "@pressmedia/webappbase";

export default {
	// **** auth header ****
	_authHeader: "Authorization",
	
	/**
	 * authHeaderの取得
	 * @returns {String}
	 */
	getAuthHeader() {
		return this._authHeader;
	},
	
	/**
	 * authHeaderのセット
	 * @param {String} authHeader
	 * @returns this
	 */
	setAuthHeader(authHeader) {
		if( !u_.isString(authHeader) || !authHeader ) {
			throw new TypeError(
				"setAuthHeader() ... arguments[0] must be string and required."
			);
		}
		
		this._authHeader = authHeader;
		return this;
	},
	
	// **** scheme ****
	_scheme: "Bearer",
	
	/**
	 * schemeの取得
	 * @returns {String}
	 */
	getScheme() {
		return this._scheme;
	},
	
	/**
	* schemeのセット
	* @return this
	*/
	setScheme(scheme) {
		if( !u_.isString(scheme) ) {
			throw new TypeError("setScheme() ... arguments[0] must be string.");
		}
		
		this._scheme = scheme;
		return this;
	},
	
	/**
	 * 認証エラー処理
	 *
	 * @param {Array} messages
	 * @param {String} methodName
	 * @param {Integer} errcode
	 * @param {String} errtype
	 * @returns Promise
	 */
	async loginErrorCallback(messages, methodName, errcode, errtype) {
		this.app.storage.del("nextToken");
		
		const msg = messages.join("<br/>");
		
		return !!msg && new Promise(resolve => {
			if(this.app.isReady) {
				this.app.alert(msg, resolve);
			} else {
				this.app.onReady(() => this.app.alert(msg, resolve));
			}
		});
	},
}
